import React from 'react';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useTheme } from '@material-ui/core/styles';
import { mentorsData } from '../data';

const Speakers = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600 }}
          variant="overline"
          color="secondary"
          align="center"
          display="block"
          gutterBottom
        >
          👩‍🏫 Tus mentoras
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
        >
          Aprende de quienes viven la noticia y la producción día tras día
        </Box>
      </Box>
      <Grid container spacing={3} justifyContent="center">
        {mentorsData.map((item, i) => (
          <Grid item xs={12} sm={6} md={5} key={i}>
            <Box
              component={Card}
              boxShadow={0}
              variant="outlined"
              sx={{
                height: '100%',
                transition: 'all .2s ease-in-out',
                '&:hover': { boxShadow: 2 },
              }}
            >
              <CardContent sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <Avatar
                  src={item.image}
                  alt={item.name}
                  sx={{
                    width: 72,
                    height: 72,
                    flexShrink: 0,
                    bgcolor: item.image ? 'transparent' : theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    fontSize: '1.25rem',
                  }}
                >
                  {!item.image && item.initials}
                </Avatar>
                <Box flex={1} minWidth={0}>
                  <Typography variant="h6" fontWeight={700} gutterBottom>
                    {item.name}
                  </Typography>
                  <Typography variant="subtitle2" color="primary" gutterBottom>
                    {item.role} · TNO Network
                  </Typography>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="div"
                    sx={{ whiteSpace: 'pre-line', '& p': { marginBottom: 1.5 } }}
                  >
                    {item.bio}
                  </Typography>
                  {item.link && (
                    <Button
                      component="a"
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="primary"
                      size="small"
                      startIcon={<OpenInNewIcon />}
                      sx={{ mt: 2 }}
                    >
                      Visitar sitio
                    </Button>
                  )}
                </Box>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Speakers;
